import type AnalyticsWidgetDisplayType from "../../types/analytics/AnalyticsWidgetDisplayType";

export const simpleAnalyticsWidgetDisplayTypes: {
  value: AnalyticsWidgetDisplayType;
  key: string;
  label: string;
}[] = [
  { value: "PIE", key: "Pie", label: "Pie chart" },
  { value: "HORIZONTAL-BAR", key: "HorizontalBar", label: "Horizontal bar chart" },
  { value: "VERTICAL-BAR", key: "VerticalBar", label: "Vertical bar chart" },
  { value: "NET-PROMOTER-SCORE", key: "Nps", label: "Net Promoter Score" },
  { value: "HISTOGRAM", key: "Histogram", label: "Histogram" },
];

const allAnalyticsWidgetDisplayTypes: {
  value: AnalyticsWidgetDisplayType;
  key: string;
  label: string;
}[] = [
  ...simpleAnalyticsWidgetDisplayTypes,
  { value: "NINE-BOX-GRID", key: "NineBoxGrid", label: "Nine box grid" },
  {
    value: "COMPLEX-SCORE-OVERVIEW",
    key: "ComplexScoreOverview",
    label: "Complex score overview",
  },
  {
    value: "NINE-BOX-GRID-EDITOR",
    key: "NineBoxGridEditor",
    label: "Nine box grid editor",
  },
  { value: "MULTI-SCORE-TABLE", key: "MultiScoreTable", label: "Multi score table" },
];

export function analyticsWidgetDisplayTypeLabel(
  displayType: string,
  translate: (key: string, fallback: string) => string,
): string {
  const known = allAnalyticsWidgetDisplayTypes.find(
    (type) => type.value === displayType,
  );
  if (!known) {
    return displayType.split("-").join(" ");
  }

  return translate(
    `Pages.Admin.AnalyticsPages.DisplayTypes.${known.key}`,
    known.label,
  );
}

export function isSimpleAnalyticsWidgetDisplayType(displayType: string): boolean {
  return simpleAnalyticsWidgetDisplayTypes.some(
    (type) => type.value === displayType,
  );
}
